var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagKyrgyzstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8244 16.2706L20.6272 17.7745L22.3298 20.8712L18.8577 20.2069L18.418 23.7141L15.9996 21.1348L13.5813 23.7141L13.1414 20.2069L9.66962 20.8711L11.3721 17.7744L8.1748 16.2706L11.3721 14.7668L9.66962 11.6701L13.1412 12.3345L13.5814 8.82715L15.9996 11.4066L18.4181 8.82715L18.8577 12.3345L22.3299 11.6701L20.6273 14.767L23.8244 16.2706Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 21.14C18.6898 21.14 20.87 18.9598 20.87 16.2704C20.87 13.5811 18.6898 11.4009 16.0004 11.4009C13.311 11.4009 11.1309 13.5811 11.1309 16.2704C11.1309 18.9598 13.311 21.14 16.0004 21.14Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5652 16.2705C13.4479 16.2705 13.3321 16.2765 13.2178 16.2879C13.2219 16.9623 13.4659 17.5796 13.8689 18.0592C14.0839 17.4806 14.4049 16.9531 14.8098 16.5016C14.4231 16.3529 14.0037 16.2705 13.5652 16.2705Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0644 18.8914C15.3569 18.9959 15.6719 19.0533 16.0004 19.0533C16.3289 19.0533 16.6438 18.9959 16.9363 18.8914C16.7769 18.2657 16.4477 17.7071 16.0004 17.2681C15.5531 17.707 15.2239 18.2657 15.0644 18.8914Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4102 14.8795C17.929 14.0479 17.0305 13.4878 16.0005 13.4878C14.9705 13.4878 14.0719 14.0479 13.5908 14.8795C14.4679 14.884 15.2904 15.1225 16.0005 15.5343C16.7105 15.1225 17.5329 14.884 18.4102 14.8795Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1904 16.5016C17.5952 16.953 17.9162 17.4806 18.1312 18.0592C18.5342 17.5796 18.7782 16.9623 18.7824 16.2879C18.668 16.2764 18.5522 16.2705 18.435 16.2705C17.9966 16.2704 17.5772 16.3528 17.1904 16.5016Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKyrgyzstan);
export default __webpack_public_path__ + "static/media/flag_kyrgyzstan.42582f11453d1f921708190d96cd6ea7.svg";
export { ForwardRef as ReactComponent };